module.exports = __webpack_public_path__ + "static/media/Rectangle.61c6b467.png";